/*
 *
 * EasySplitDetails constants
 *
 */
export const BASE_ACTION_CONSTANT = 'app/EasySplitDetails';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const SAVE_VENDOR_DETAILS = `${BASE_ACTION_CONSTANT}/SAVE_VENDOR_DETAILS`;

export const GET_VENDOR_KYC_DETAILS = `${BASE_ACTION_CONSTANT}/GET_VENDOR_KYC_DETAILS`;

export const SAVE_VENDOR_KYC_DETAILS = `${BASE_ACTION_CONSTANT}/SAVE_VENDOR_KYC_DETAILS`;

export const GET_KYC_DOCS = `${BASE_ACTION_CONSTANT}/GET_KYC_DOCS`;

export const SAVE_KYC_DOCS = `${BASE_ACTION_CONSTANT}/SAVE_KYC_DOCS`;

export const ADJUST_BALANCE = `${BASE_ACTION_CONSTANT}/ADJUST_BALANCE`;

export const DOWNLOAD_DOC = `${BASE_ACTION_CONSTANT}/DOWNLOAD_DOC`;

export const SAVE_VENDOR_BY_ID = `${BASE_ACTION_CONSTANT}/SAVE_VENDOR_BY_ID`;

export const SAVE_KYC_RESPONSE = `${BASE_ACTION_CONSTANT}/SAVE_KYC_RESPONSE`;

export const UPDATE_VENDOR = `${BASE_ACTION_CONSTANT}/UPDATE_VENDOR`;

export const UPLOAD_KYC_DATA = `${BASE_ACTION_CONSTANT}/UPLOAD_KYC_DATA`;

export const GET_VENDOR_OD_BALANCE = `${BASE_ACTION_CONSTANT}/GET_VENDOR_OD_BALANCE`;

export const INITIATE_VENDOR_OD = `${BASE_ACTION_CONSTANT}/INITIATE_VENDOR_OD`;

export const RESET_REDUCER_STATES = `${BASE_ACTION_CONSTANT}/RESET_REDUCER_STATES`;

export const GET_SETTLEMENT_CONFIG = `${BASE_ACTION_CONSTANT}/GET_SETTLEMENT_CONFIG`;

export const SAVE_SETTLEMENT_CONFIG = `${BASE_ACTION_CONSTANT}/SAVE_SETTLEMENT_CONFIG`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const GET_DOCS_BY_USER = `${BASE_ACTION_CONSTANT}/GET_DOCS_BY_USER`;

export const SAVE_VENDOR_DOCS = `${BASE_ACTION_CONSTANT}/SAVE_VENDOR_DOCS`;

export const UPLOAD_VENDOR_DOCS = `${BASE_ACTION_CONSTANT}/UPLOAD_VENDOR_DOCS`;

export const VERIFY_PAN = `${BASE_ACTION_CONSTANT}/VERIFY_PAN`;

export const VERIFY_CIN = `${BASE_ACTION_CONSTANT}/VERIFY_CIN`;

export const VERIFY_GST = `${BASE_ACTION_CONSTANT}/VERIFY_GST`;

export const GET_DOCS_BY_USER_URL = {
  url: '/common/onboardingsvc/users/$merchantVendorId$/documents',
  method: 'GET',
};

export const UPLOAD_VENDOR_DOCS_URL = {
  url: `/common/onboardingsvc/users/$userName$`,
  method: 'POST',
};

export const VERIFY_PAN_URL = {
  url: '/common/onboardingsvc/verification/pan',
  method: 'POST',
};

export const VERIFY_CIN_URL = {
  url: '/common/onboardingsvc/verification/cin',
  method: 'POST',
};

export const VERIFY_GST_URL = {
  url: '/common/onboardingsvc/verification/gstin',
  method: 'POST',
};

export const ALL_SETTLEMENT_DETIALS = [
  'amountToBeSettled',
  'nextSettlementDate',
];

export const ALL_ACCOUNT_DETAILS = [
  'merchantVendorId',
  'phone',
  'name',
  'addedOn',
  'email',
];

export const ALL_BANK_DETAILS = [
  'accountHolder',
  'ifsc',
  'accountNumber',
  'vpa',
  'remarks',
];

export const ALL_KYC_INDIVIDUAL_DETAILS = [
  'accountType',
  'businessType',
  'pan',
  'uidai',
  'passport',
  'voterId',
  'drivingLicense',
];

export const ALL_KYC_BUSINESS_DETAILS = [
  'accountType',
  'businessType',
  'pan',
  'cin',
  'gst',
];

export const DETAILS_DISPLAY_TEXT_MAPPING = {
  amountToBeSettled: 'Unsettled Amount',
  nextSettlementDate: 'Upcoming Settlement Date',
  merchantVendorId: 'Vendor Id',
  phone: 'Phone No.',
  name: 'Vendor Name',
  addedOn: 'Creation Date & Time',
  email: 'Email',
  accountHolder: 'Account Holder Name',
  ifsc: 'IFSC Code',
  accountNumber: 'Account Number',
  accountType: 'Vendor Type',
  businessType: 'Business Type',
  gst: 'GST Number & Document',
  cin: 'CIN Number & Document',
  uidai: 'Aadhaar & Document',
  voterId: 'Voter Id & Document',
  passport: 'Passport & Document',
  drivingLicense: 'Driving License & Document',
  settlementScheduleMessage: 'Current Settlement Cycle',
  vpa: 'VPA',
  remarks: 'Note',
};

export const DOCTYPE_NAME_MAPPING = {
  DL: 'drivingLicense',
  PAN: 'pan',
  PASSPORT_FRONT: 'passport',
  PASSPORT_BACK: 'passport',
  UIDAI_FRONT: 'uidai',
  UIDAI_BACK: 'uidai',
  VOTER_ID: 'voterId',
  GST: 'gst',
  CIN: 'cin',
};

export const DATE_FIELDS = ['nextSettlementDate', 'addedOn'];

export const POSSIBLE_DOCS = [
  'PAN',
  'PASSPORT_FRONT',
  'PASSPORT_BACK',
  'UIDAI_FRONT',
  'UIDAI_BACK',
  'VOTER_ID',
  'DL',
  'GST',
  'CIN',
];

export const manageVendorOptions = [
  { key: 1, text: 'Block Vendor', value: 'BLOCK', icon: 'delete' },
  { key: 2, text: 'Delete Vendor', value: 'DELETE', icon: 'delete' },
];

export const DELETE_CONFIRMATION_MODAL = 'DELETE_CONFIRMATION_MODAL';

export const BLOCK_CONFIRMATION_MODAL = 'BLOCK_CONFIRMATION_MODAL';

export const UNBLOCK_CONFIRMATION_MODAL = 'UNBLOCK_CONFIRMATION_MODAL';

export const CRITICAL_VENDOR_EDIT_SUCCESS = 'CRITICAL_VENDOR_EDIT_SUCCESS';

export const VENDOR_ADDED_FAILED = 'VENDOR_ADDED_FAILED';

export const NON_CRITICAL_VENDOR_EDIT_SUCCESS =
  'NON_CRITICAL_VENDOR_EDIT_SUCCESS';

export const EDIT_VENDOR = 'EDIT_VENDOR';

export const BLOCK = 'BLOCK';

export const DELETE = 'DELETE';

export const BLOCKED = 'BLOCKED';

export const UNBLOCK_VENDOR = 'Unblock Vendor';

export const BLOCK_VENDOR = 'Block Vendor';

export const ON_HOLD = 'ON_HOLD';

export const DELETED = 'DELETED';

export const BANK_VALIDATION_FAILED = 'BANK_VALIDATION_FAILED';

export const VENDOR_ADDED_FAILED_INFO =
  'There was a problem saving the details. Please add the vendor details and try again.';

export const BLOCK_CONFIRMATION_MODAL_INFO =
  'No settlements can be made to this vendor after you block them. You can later unblock this vendor from the Vendor Details screen. Do you want to block this vendor?';

export const UNBLOCK_CONFIRMATION_MODAL_INFO =
  'You can continue to process settlements with this vendor after you unblock them. Do you want to unblock this vendor?';

export const CRITICAL_VENDOR_EDIT_SUCCESS_INFO =
  'During the review period, transactions are allowed but settlement will be on hold till the status is active';

export const BLOCKED_BANNER_INFO =
  'Settlements to this vendor is stopped as the vendor is blocked. Unblock the vendor to process settlements.';

export const ON_HOLD_BANNER_INFO =
  'Some of the documents are rejected. Upload the correct documents again to process the vendor settlements as per the settlement cycle.';

export const KYC_DOCS = {
  pan: [],
  drivingLicense: [],
  uidai: [],
  passport: [],
  voterId: [],
  cin: [],
  gst: [],
};

export const VENDOR_DOCS_HEADING_DATA = [
  { key: 'submittedOn', displayName: 'Submitted On' },
  { key: 'docName', displayName: 'Document Type' },
  { key: 'docVal', displayName: 'Details & Document Link' },
  { key: 'status', displayName: 'Status' },
  { key: 'remarks', displayName: 'Remarks' },
];

export const DOC_STATUS_COLOR_MAPPING = {
  ACTION_REQUIRED: 'danger',
  VERIFIED: 'success',
};

export const DOC_STATUS_TEXT_MAPPING = {
  ACTION_REQUIRED: 'Rejected',
  IN_KYC_REVIEW: 'In Review',
};

export const DELETE_BANK_DETAILS = [
  'name',
  'accountHolder',
  'vpa',
  'ifsc',
  'accountNumber',
];
